<div class="summary-grant-content">
  <div class="summary-grant-content__summary-container">
    <div class="summary-grant-content__summary-sections">
      <div class="summary-grant-content__section">

        <h3 class="summary-grant-content__section-heading">
          {{ 'contribute.step.summary' | translateLang }}
        </h3>

        <!-- Charity Name -->
        <div class="summary-grant-row">
          <span class="summary-grant-row__label">{{ (currentFund?.fundType === fundTypes.CHARITY ? 'distribution.summary.charity_name' : 'grant.summary.charity_name') | translateLang }}</span>
          <span class="summary-grant-row__value">
            {{ displayData.receiverFundName }}
            @if (displayData.receiverFundNumberDisplay || displayData.receiverFundNumber) {
              <span class="summary-grant-row__value">(#{{ displayData.receiverFundNumberDisplay || displayData.receiverFundNumber }})</span>
            }
          </span>
        </div>

        <!-- Project Name -->
        @if (displayData.charityProjectName) {
          <div class="summary-grant-row">
            <span class="summary-grant-row__label">{{ 'grant.summary.project_name' | translateLang }}</span>
            <span class="summary-grant-row__value">{{ displayData.charityProjectName }}</span>
          </div>
        }

        <!-- Total Amount -->
        <div class="summary-grant-row">
          <span class="summary-grant-row__label">{{ (currentFund?.fundType === fundTypes.CHARITY ? 'distribution.summary.total_amount' : 'grant.summary.total_amount') | translateLang }}</span>
          <span class="summary-grant-row__value">
            {{ formatNumberValue(displayData.amount) }} {{ currency }}
          </span>
        </div>

        <!-- Fees & Assessments (parent — shown only if calculatedGrantAssessmentExpense || processingAssessmentExpense) -->
        @if (displayData.calculatedGrantAssessmentExpense || displayData.processingAssessmentExpense) {
          <div class="summary-grant-row">
            <span class="summary-grant-row__label">{{ (currentFund?.fundType === fundTypes.CHARITY ? 'distribution.summary.fees_and_assessments' : 'grant.summary.fees_and_assessments') | translateLang }}</span>
            <span class="summary-grant-row__value summary-grant-row__value--fees">
              <button class="summary-breakdown-toggle" type="button" (click)="toggleFeesBreakdown()">
                {{ formatNumberValue(totalFees) }} {{ currency }}
                <app-caret-icon
                  [isOpen]="!isGrantFeesCollapsed"
                  [width]="16"
                  [height]="16">
                </app-caret-icon>
              </button>
            </span>
          </div>

          @if (!isGrantFeesCollapsed) {
            @if (displayData.calculatedGrantAssessmentExpense) {
              <div class="summary-grant-row summary-grant-row--child">
                <span class="summary-grant-row__label">{{ (currentFund?.fundType === fundTypes.CHARITY ? 'distribution.summary.assessment' : 'grant.summary.assessment') | translateLang }}</span>
                <span class="summary-grant-row__value">
                  {{ formatNumberValue(displayData.calculatedGrantAssessmentExpense) }} {{ currency }}
                </span>
              </div>
            }
            @if (displayData.processingAssessmentExpense) {
              <div class="summary-grant-row summary-grant-row--child">
                <span class="summary-grant-row__label">{{ (currentFund?.fundType === fundTypes.CHARITY ? 'distribution.summary.processing_assessment' : 'grant.summary.processing_assessment') | translateLang }}</span>
                <span class="summary-grant-row__value">
                  {{ formatNumberValue(displayData.processingAssessmentExpense) }} {{ currency }}
                </span>
              </div>
            }
            @if (displayData.supplementalGrantAssessment) {
              <div class="summary-grant-row summary-grant-row--child">
                <span class="summary-grant-row__label">{{ (currentFund?.fundType === fundTypes.CHARITY ? 'distribution.summary.supplemental_assessment' : 'grant.summary.supplemental_assessment') | translateLang }}</span>
                <span class="summary-grant-row__value">
                  {{ formatNumberValue(displayData.supplementalGrantAssessment) }} {{ currency }}
                </span>
              </div>
            }
          }
        }

        <!-- Distribution Amount -->
        @if (displayData.grantAmount) {
          <div class="summary-grant-row">
            <span class="summary-grant-row__label">{{ (currentFund?.fundType === fundTypes.CHARITY ? 'distribution.summary.distribution_amount' : 'grant.summary.distribution_amount') | translateLang }}</span>
            <span class="summary-grant-row__value">
              {{ formatNumberValue(displayData.grantAmount) }} {{ currency }}
            </span>
          </div>
        }

        <!-- Timing -->
        @if (!displayData.isRecurring) {
          <div class="summary-grant-row">
            <span class="summary-grant-row__label">{{ (currentFund?.fundType === fundTypes.CHARITY ? 'distribution.form.timing.label' : 'grant.form.timing.label') | translateLang }}</span>
            <span class="summary-grant-row__value">
              {{
                displayData.timing === 'As soon as possible'
                  ? ((currentFund?.fundType === fundTypes.CHARITY ? 'distribution.form.timing.asap' : 'grant.form.timing.asap') | translateLang)
                  : formatDateValue(displayData.timing)
              }}
            </span>
          </div>
        }

        <!-- Recurring -->
        @if (displayData.isRecurring) {
          <div class="summary-grant-row">
            <span class="summary-grant-row__label">{{ (currentFund?.fundType === fundTypes.CHARITY ? 'distribution.form.timing.label' : 'grant.form.timing.label') | translateLang }}</span>
            <span class="summary-grant-row__value">
              {{ 'donate.recurring.contribution.labels.pattern.' + displayData.recurrencePattern?.toLowerCase()?.replaceAll('_', '.') | translateLang }}
            </span>
          </div>
          <div class="summary-grant-row">
            <span class="summary-grant-row__label">{{ (currentFund?.fundType === fundTypes.CHARITY ? 'distribution.summary.start_date' : 'grant.summary.start_date') | translateLang }}</span>
            <span class="summary-grant-row__value">{{ formatDateValue(displayData.startDate) }}</span>
          </div>
          <div class="summary-grant-row">
            <span class="summary-grant-row__label">{{ (currentFund?.fundType === fundTypes.CHARITY ? 'distribution.summary.end_date' : 'grant.summary.end_date') | translateLang }}</span>
            <span class="summary-grant-row__value">
              @if (displayData.endDate) {
                {{ formatDateValue(displayData.endDate) }}
              } @else {
                {{ (currentFund?.fundType === fundTypes.CHARITY ? 'distribution.summary.no_end_date' : 'grant.summary.no_end_date') | translateLang }}
              }
            </span>
          </div>
        }

        <!-- Anonymous -->
        @if (displayData.privacy && currentFund?.fundType !== fundTypes.CHARITY) {
          <div class="summary-grant-row">
            <span class="summary-grant-row__label">{{ 'grant.summary.anonymous' | translateLang }}</span>
            <span class="summary-grant-row__value">{{ displayData.privacy }}</span>
          </div>
        }

        <!-- Charity Instructions -->
        @if (displayData.charityInstruction) {
          <div class="summary-grant-row">
            <span class="summary-grant-row__label">{{ (currentFund?.fundType === fundTypes.CHARITY ? 'distribution.summary.charity_instructions' : 'grant.summary.charity_instructions') | translateLang }}</span>
            <span class="summary-grant-row__value">{{ displayData.charityInstruction }}</span>
          </div>
        }

        <!-- Additional Notes -->
        @if (displayData.additionalNotes) {
          <div class="summary-grant-row">
            <span class="summary-grant-row__label">{{ (currentFund?.fundType === fundTypes.CHARITY ? 'distribution.summary.org_instructions' : 'grant.summary.org_instructions') | translateLang }}</span>
            <span class="summary-grant-row__value">{{ displayData.additionalNotes }}</span>
          </div>
        }

      </div>
    </div>
  </div>

  <!-- Note -->
  @if (currentFund?.fundType === fundTypes.CHARITY && isSGH) {
    <div class="summary-note">
      <p class="mb-1" [innerHTML]="'distribution.summary.note' | translateLang | translateCut: 0"></p>
      <ul class="summary-note__list">
        <li>{{ 'distribution.summary.note' | translateLang | translateCut: 1 }}</li>
        <li>{{ 'distribution.summary.note' | translateLang | translateCut: 2 }}</li>
      </ul>
    </div>
  } @else if (currentFund?.fundType === fundTypes.CHARITY){
    <div class="summary-note">
      <p [innerHTML]="'distribution.summary.note'  | translateLang"></p>
    </div>
  }

</div>
